import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { IncidencesProvider } from 'modules/bookkeepers/hooks/IncidencesContext'
import IncidencesPageBody from 'modules/payroll_bundle/pages/IncidencesPage/components/_IncidencesPageBody'

import type { IncidenceItem } from './utils'

interface Props {
  dataCollectionTable: React.ReactNode
  incidenceDetail: React.ReactNode
  openedIncidenceId: number
  incidencesData: IncidenceItem[]
}

const EmployeeUpdatesDataCollectionContent = ({
  dataCollectionTable,
  incidenceDetail,
  openedIncidenceId,
  incidencesData,
}: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const incidences = React.useMemo(
    () => incidencesData.map((incidence) => ({ ...incidence })),
    [incidencesData]
  )

  const handleCloseSidepanel = () => {
    navigate(navigation.compensations.employeeUpdates.fullPath())
  }

  return (
    <IncidencesProvider value={incidences}>
      <IncidencesPageBody
        incidencesTable={dataCollectionTable}
        incidenceDetail={incidenceDetail}
        selectedIncidenceId={openedIncidenceId}
        loading={false}
        onCloseSidepanel={handleCloseSidepanel}
      />
    </IncidencesProvider>
  )
}

export default EmployeeUpdatesDataCollectionContent
